<script setup>
import { isArray } from 'lodash-es'

defineProps({
  checkIconClass: {
    type: String,
    default: 'text-eerie-black'
  },
  checkedClass: {
    type: String,
    default: 'bg-mint border border-mint'
  }
})

const attrs = useAttrs()
const checked = defineModel({
  type: [String, Boolean, Array, Number]
})

if (!checked.value) {
  checked.value = attrs.type === 'checkbox' ? [] : attrs.type === 'radio' ? null : false
}

const handle = () => {
  if (attrs.type === 'checkbox') {
    if (isArray(checked.value)) {
      const index = checked.value.indexOf(attrs.value)
      if (index === -1) {
        checked.value = [...checked.value, attrs.value]
      } else {
        checked.value = checked.value.filter((_, i) => i !== index)
      }
      return
    }
  } else if (attrs.type === 'radio') {
    checked.value = attrs.value
    return
  }
  checked.value = !checked.value
}

const isElementChecked = computed(() => {
  if (isArray(checked.value) && attrs.type === 'checkbox') {
    return checked.value.includes(attrs.value)
  } else if (attrs.type === 'radio') {
    return checked.value === attrs.value
  }
  return checked.value
})

</script>

<template>
  <label class="relative inline-flex cursor-pointer items-center">
    <input
      v-bind="{
        name: attrs.name,
        id: attrs.id,
        required: attrs.required,
        disabled: attrs.disabled,
        type: attrs.type || 'checkbox',
        value: attrs.value,
        onChange: handle
      }"
      :model-value="checked"
      :checked="isElementChecked"
      :class="[
        `size-6 max-w-6 shrink-0 appearance-none rounded-full border border-body-gray bg-cover bg-center`,
        {
          [`${checkedClass} app-checkbox--checked`]: isElementChecked,
          'bg-transparent': !isElementChecked,
          'mr-2': !!$slots.default
        },
        attrs.class,
      ]"
      @update:model-value="handle">
    <slot :checked="checked" />
  </label>
</template>

<style scoped lang="postcss">
input[type="checkbox"].app-checkbox--checked::before,
input[type="radio"].app-checkbox--checked::before{
  @apply absolute w-[8px] h-[12px] left-3 border-r-2 border-b-2 border-black my-auto;
  content: '';
  top: calc(50% - 1px);
  transform: translate(-50%, -50%) rotate(40deg);
}
</style>
